module.exports = __webpack_public_path__ + "img/jet.c32fe03e.png";